import React from "react";
import { Container } from "react-bootstrap";
import { ContentWrapper, Sida, Rubrik, Stycke } from "./ContentStyles";
import Album from "./Album";
import "./Gallery.scss";

const GalleryPage = () => {
    return (
        <ContentWrapper className="gallery-page">
            <Container>
                <Sida className="gallery-page__content">
                    <div className="gallery-page__header">
                        <Rubrik className="gallery-page__title">Galleri</Rubrik>
                        <Stycke className="gallery-page__lead">
                            Inspiration och exempel på hur din butik kan se ut.
                        </Stycke>
                    </div>

                    <div className="gallery-page__album">
                        <Album />
                    </div>
                </Sida>
            </Container>
        </ContentWrapper>
    );
};

export default GalleryPage;
